import React from "react";

const Portfolio = ({ data }) => {
  if (data) {
    var projects = data.projects.map(function (projects) {
      var projectImage = "images/portfolio/" + projects.image;
      return (
        <div key={projects.title} className="columns portfolio-item">
          <div className="item-wrap">
            <a href={projects.url} title={projects.title}>
              <img alt={projects.title} src={projectImage} />
              <div className="overlay">
                <div className="portfolio-item-meta">
                  <h5>{projects.title}</h5>
                  <p>{projects.category}</p>
                </div>
              </div>
              <div className="link-icon">
                <i className="fa fa-link"></i>
              </div>
            </a>
          </div>
        </div>
      );
    });
  }

  return (
    <section id="portfolio">
      <div className="row">
        <div className="twelve columns collapsed">
          <h1 className="lasth1">Últimos proyectos</h1>

          <div
            id="portfolio-wrapper"
            className="bgrid-quarters s-bgrid-thirds cf"
          >
            <div className="div-dev">
              <h2 className="h1-dev-movie">Movie App</h2>
              <a href="https://movie-app-jade-three.vercel.app/">
                <img src="../../images/Movie.png" alt="" className="img-devs" />
              </a>
              <div className="tegonologias-used-up">
                <div className="tegonologias-used">
                  <img
                    src="./images/HTML.png"
                    alt="HTML IMG"
                    className="html-used"
                  />

                  <img src="./images/CSS.png" alt="" className="css-used" />

                  <img src="./images/JS.jpg" alt="" className="js-used" />

                  <img
                    src="./images/React2.png"
                    alt=""
                    className="react-used"
                  />

                  <img src="./images/Redux.png" alt="" className="redux-used" />
                </div>
              </div>
            </div>

            <div className="div-devt">
              <h2 className="h1-dev-movie">Food App</h2>
              <a href="https://webfoodst.vercel.app">
                <img src="../../images/Food.png" alt="" className="img-devs" />
              </a>
              <div className="tegonologias-used-up">
                <div className="tegonologias-used">
                  <img src="./images/CSS.png" alt="" className="css-used" />

                  <img
                    src="./images/React2.png"
                    alt=""
                    className="react-used"
                  />

                  <img src="./images/Redux.png" alt="" className="redux-used" />

                  <img
                    src="./images/Expressimg.png"
                    alt=""
                    className="redux-used"
                  />

                  <img
                    src="./images/Sequelize.png"
                    alt=""
                    className="sequelize-used"
                  />

                  <img
                    src="./images/Postgress.png"
                    alt=""
                    className="postgress-used"
                  />
                </div>
              </div>
            </div>

            <div className="div-devt-app">
              <h2 className="h1-dev-movie">Banco del sol</h2>
              <a href="https://www.youtube.com/watch?v=XzCn3DgDVsY">
                <img
                  src="https://media.discordapp.net/attachments/877550366454079550/883515256494780436/12321321312312.png?width=853&height=480"
                  alt=""
                  className="img-devs"
                />
              </a>
              <div className="tegonologias-used-up">
                <div className="tegonologias-used">
                  <h2 className="h1-dev-app">
                    React Native - TypeScript - NestJs - MongoDB
                  </h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
